/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetReservationNotesResponse
 */
export interface SetReservationNotesResponse {
    /**
     * 
     * @type {string}
     * @memberof SetReservationNotesResponse
     */
    bookingId: string;
    /**
     * 
     * @type {string}
     * @memberof SetReservationNotesResponse
     */
    notes?: string | null;
}

/**
 * Check if a given object implements the SetReservationNotesResponse interface.
 */
export function instanceOfSetReservationNotesResponse(value: object): value is SetReservationNotesResponse {
    if (!('bookingId' in value) || value['bookingId'] === undefined) return false;
    return true;
}

export function SetReservationNotesResponseFromJSON(json: any): SetReservationNotesResponse {
    return SetReservationNotesResponseFromJSONTyped(json, false);
}

export function SetReservationNotesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetReservationNotesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'bookingId': json['booking_id'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function SetReservationNotesResponseToJSON(json: any): SetReservationNotesResponse {
    return SetReservationNotesResponseToJSONTyped(json, false);
}

export function SetReservationNotesResponseToJSONTyped(value?: SetReservationNotesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'booking_id': value['bookingId'],
        'notes': value['notes'],
    };
}

